import { consola } from 'consola';

export const logger = consola;
consola.level = import.meta.env.DEV ? 5 : 3;
